module.exports = __webpack_public_path__ + "static/media/visit-flanders-logo.fabc6240.png";